// @Deprecated: This file is deprecated and will be removed in the future.
// TODO LEGACY DEPRECATION: Remove this file when deprecating legacy app

// Third-party
import React from 'react';
import classNames from 'classnames';
import { Dropdown } from 'react-bootstrap';

// Components
import { MenuToggle } from '../../../components/buttons';
import { SaveComparisonModal } from '../../../components/modals';

// Utils
import { formatMessage } from '../../../../utils/i18n';
import { PERMISSIONS, userHasPermission } from '@/utils/permissions';

import ReducedComparison from '@/types/reduced-comparison';
import GenericContact from '@/types/generic-contact';
import User from '@/types/user';
import Comparison from '@/types/comparison';

type Props = {
  user: User;
  comparison: ReducedComparison;
  onDeleteComparison: (comparison: ReducedComparison) => void;
  onSaveComparison: (id: string, name: string, contact?: GenericContact, isNewlyAssigned?: boolean) => Promise<Comparison>;
};

type State = {
  saveComparisonModal: boolean;
  isSaving: boolean;
};

class ComparisonTableMenu extends React.Component<Props> {
  readonly state: State = {
    saveComparisonModal: false,
    isSaving: false,
  };

  hideSaveComparisonModal = () => {
    this.setState({ saveComparisonModal: false });
  };

  showSaveComparisonModal = () => {
    this.setState({ saveComparisonModal: true });
  };

  onSaveComparison = (name: string, contact?: GenericContact) => {
    const { comparison } = this.props;
    const isNewlyAssigned = true;

    if (!comparison._id) {
      return;
    }

    this.setState({ isSaving: true });

    this.props
      .onSaveComparison(comparison._id, name, contact, isNewlyAssigned)
      .then(() => {
        this.hideSaveComparisonModal();
      })
      .finally(() => {
        this.setState({ isSaving: false });
      });
  };

  getMenuItems = () => {
    const { comparison, onDeleteComparison, user } = this.props;

    // Note that PERMISSIONS.COMPARISONS_DELETE exists, but Stairs confirmed that it is not used here to show or hide the delete menu item

    return [
      {
        value: formatMessage('ComparisonsTable.Menu.SaveToContact'),
        onClick: this.showSaveComparisonModal,
        hidden: comparison.contact || !userHasPermission(user, PERMISSIONS.PORTFOLIOS_SAVE_TO_CONTACT),
        icon: 'icon-save-to-contact',
      },
      {
        value: formatMessage('ComparisonsTable.Menu.DeleteComparison'),
        className: 'destructive',
        onClick: onDeleteComparison,
        hidden: comparison.availableActions != null ? !comparison.availableActions.delete : false,
        icon: 'icon-ds-delete',
      },
    ].filter(i => !i.hidden);
  };

  renderOptions = (): JSX.Element[] => {
    const { comparison } = this.props;
    return this.getMenuItems().map(item => (
      <Dropdown.Item
        key={item.value}
        aria-label={`${item.value} menu item`}
        role="menuitem"
        as="button"
        className={classNames(item.className)}
        onClick={() => item.onClick(comparison)}
      >
        <i className={item.icon} />
        <span>{item.value}</span>
      </Dropdown.Item>
    ));
  };

  render() {
    const options = this.renderOptions();
    const { comparison, user } = this.props;
    const { saveComparisonModal, isSaving } = this.state;

    if (options.length === 0) {
      return null;
    }

    return (
      <div onClick={e => e.stopPropagation()}>
        <div className="comparison-table-menu table-menu">
          <MenuToggle options={options} alignRight />
        </div>

        {saveComparisonModal && (
          <SaveComparisonModal
            requireContact
            user={user}
            show={saveComparisonModal}
            comparison={comparison}
            isSaving={isSaving}
            onSave={this.onSaveComparison}
            onCancel={this.hideSaveComparisonModal}
          />
        )}
      </div>
    );
  }
}

export default ComparisonTableMenu;
